<template>
  <labeled-form-control label="Address" :optional="true">
    <div v-if="editing" class="mb-2">
      <address-manual-input v-model="clientAddressLines" :disabled="clientAddressUpdated"/>
      <a v-if="!clientAddressUpdated" @click="editing=false" class="link" style="cursor: pointer">Back</a>
    </div>
    <template v-else>
      <div v-if="!!addressString" class="mb-2">
        <div class="text-left">{{addressString}}</div>
        <a v-if="!clientAddressUpdated" @click="editing=true" class="link" style="cursor: pointer">Edit</a>
      </div>
      <template v-else>
        <div v-if="canUseLookup" class="mb-2">
          <address-lookup  v-model="clientAddressLines" :disabled="clientAddressUpdated" class="mb-2"/>
          <a v-if="!clientAddressUpdated" @click="editing=true" class="link" style="cursor: pointer">Enter Manually</a>
        </div>
        <address-manual-input v-else-if="!canUseLookup && loadedCountryFormat" v-model="clientAddressLines" :disabled="clientAddressUpdated"/>
      </template>
    </template>
  </labeled-form-control>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { AddressHelper } from '../../../helpers/AddressHelper'
import { FormatCountryCacheMixin } from '../../../mixins/Format/FormatCountryCacheMixin'
import { ClientAddressUploadMixin } from '../../../mixins/Registration/ClientAddressUploadMixin'
import { ClientOnboardingInviteCacheMixin } from '../../../mixins/Registration/ClientOnboardingInviteCacheMixin'
import LabeledFormControl from '../../Layout/LabeledFormControl.vue'
import ClientAddressFieldManualInput from './ClientAddressFieldManualInput.vue'
import ClientAddressFieldLookup from './ClientAddressFieldLookup.vue'

export default {
  name: 'ClientAddressField',
  mixins: [FormatCountryCacheMixin, ClientAddressUploadMixin, ClientOnboardingInviteCacheMixin],
  data () {
    return {
      editing: false
    }
  },
  computed: {
    ...mapState('ApplicationEvents', [
      'saveRegistrationEvent'
    ]),
    clientAddressLines: {
      get () {
        return {
          line1: this.line1,
          line2: this.line2,
          line3: this.line3,
          town: this.town,
          county: this.county,
          postCode: this.postCode
        }
      },
      set (value) {
        this.setClientAddressLines(value)
      }
    },
    addressString () {
      return AddressHelper.getAddressLines(this.clientAddressLines).join(', ')
    },
    canUseLookup () {
      return this.countryFormat && this.countryFormat.addressLookup
    }
  },
  watch: {
    saveRegistrationEvent () {
      this.handleUpdateEvent()
    },
    clientDetailsUpdated () {
      this.handleUpdateEvent()
    }
  },
  methods: {
    ...mapMutations('ClientOnboardingInvites', [
      'setClientAddressUpdated'
    ]),
    setClientAddressLines (address) {
      this.line1 = address ? address.line1 : ''
      this.line2 = address ? address.line2 : ''
      this.line3 = address ? address.line3 : ''
      this.town = address ? address.town : ''
      this.county = address ? address.county : ''
      this.postCode = address ? address.postCode : ''
    },
    afterAddClientAddress () {
      this.setClientAddressUpdated()
    },
    afterUpdateClientAddress () {
      this.setClientAddressUpdated()
    },
    handleUpdateEvent () {
      if (!this.clientAddressUpdated && this.clientDetailsUpdated) {
        this.tryUploadClientAddress()
      }
    }
  },
  components: {
    'labeled-form-control': LabeledFormControl,
    'address-manual-input': ClientAddressFieldManualInput,
    'address-lookup': ClientAddressFieldLookup
  }
}
</script>
